module.exports = __webpack_public_path__ + "img/ar02.8eea3259.jpg";